
function formatTitle (title, currentArray, currentIndex, currentOpts) {
  return '<div id="tip7-title"><span><a href="javascript:;" onclick="$.fancybox.close();"><img style="border: none" src="/static/img/lightbox/close.gif" /></a></span>' + (title && title.length ? '<b>' + title + '</b>' : '') + 'Obrázek ' + (currentIndex + 1) + ' z ' + currentArray.length + '</div>'
}

export default function (selector) {
  window.jQuery(selector).fancybox({
    'showCloseButton': false,
    'titlePosition': 'inside',
    'titleFormat': formatTitle
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/fancybox.js